import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { Spinner } from '../components/atoms/Spinner/Spinner';

/**
 * Un componente de orden superior que protege las rutas.
 * Verifica el estado de autenticación del usuario con Firebase.
 * - Si el usuario está autenticado, renderiza el componente hijo (a través de <Outlet />).
 * - Si el usuario no está autenticado, lo redirige a la página de login.
 * - Muestra un indicador de carga mientras se verifica el estado.
 */
export const ProtectedRoute: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // onAuthStateChanged es un observador que se ejecuta cuando el usuario
        // inicia o cierra sesión.
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        // Limpiamos el observador cuando el componente se desmonta.
        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div className="flex justify-center items-center h-screen"><Spinner size="large" /></div>;
    }

    return user ? <Outlet /> : <Navigate to="/login" replace />;
};
